<ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">
  <!-- Item wrapper -->
  <div class="fuse-vertical-navigation-item-wrapper">
    <!-- Item with an internal link -->
    <ng-container *ngIf="item.link && !item.externalLink && !item.disabled">
      <a
        class="fuse-vertical-navigation-item"
        [routerLink]="[item.link]"
        [routerLinkActive]="'fuse-vertical-navigation-item-active'"
        [routerLinkActiveOptions]="isActiveMatchOptions"
        [style.border-width.px]="isChild ? 0 : 3"
      >
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
      </a>
    </ng-container>
  </div>

  <!-- Item template -->
  <ng-template #itemTemplate>
    <!-- Icon -->
    <div class="fuse-vertical-navigation-item-icon">
      <ng-container *ngIf="item.icon">
        <i [class]="item.icon"></i>
      </ng-container>
      <ng-container *ngIf="item.svgIcon">
        <img [src]="item.svgIcon" alt="svg-icon" />
      </ng-container>
    </div>
    <!-- Title & Subtitle -->
    <div class="fuse-vertical-navigation-item-title-wrapper">
      <div class="fuse-vertical-navigation-item-title">
        {{ item.title }}
      </div>
    </div>
  </ng-template>
</ng-container>
